// src/Utils/request.tsx
import axios from "axios";
import { beginTrackedRequest, endTrackedRequest } from "./loadingIndicator";
import { clearSessionAndRedirectToLogin } from "./session";
import { notifySuccessForResponse, notifyErrorForResponse } from "./requestFeedback";

export const HTTP_STATUS_CONFLICT = 409;

// Axios defaults to no timeout; callers needing more time (e.g. uploads) can override via config.
export const DEFAULT_REQUEST_TIMEOUT_MS = 180000;

const request = axios.create({ timeout: DEFAULT_REQUEST_TIMEOUT_MS });

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    beginTrackedRequest(config?.url);
    return config;
  },
  (error) => {
    endTrackedRequest();
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    notifySuccessForResponse(response);
    endTrackedRequest();
    return response;
  },
  (error) => {
    endTrackedRequest();
    if (error.response?.status === 401) {
      clearSessionAndRedirectToLogin();
    }
    notifyErrorForResponse(error);
    return Promise.reject(error);
  }
);

export default request;
